
import React, { useState } from 'react';
import _ from 'lodash';
import AddIcon from '@material-ui/icons/Add';
import PropTypes from 'prop-types';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import { withStyles } from '@material-ui/core/styles';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { ReactComponent as ImportedSVG } from '../../assets/pictures/promotion.svg';
import { mainColor } from '../../constants/theme';
import {
  Paper,
  TableFooter,
  PromoModal,
  Button,
  EmptyView,
  Table,
  BackButton,
  Switch
} from '../../components';
import * as actions from '../../actions/index';
import { closeModal, handleRemove, handleClick, getAllShopsPromotions } from './PromoCodes.services';
import { FREEDELIVERY, PROMOTYPES, marketing, SUITABLE_ORDER_TYPES, ZELTY } from '../../constants';
import { displayPriceFormat, isObjectNotEmpty } from '../../utils/tools';
import { styles } from './PromoCodes.styles';
import { EMPTY_DESIGN_PROMOS_TEXT, EMPTY_DESIGN_PROMOS_TITLE } from '../../constants/dishopInfo';
import { PROMO_TABLE_HEAD } from '../../constants/table';
import { parseDate } from '../../utils/suitableDate';
import { hasExternalIntegration } from 'src/utils/externalIntegration';
function CodePromo({ classes, orderTypes: shopOrderTypes, promos = {}, history = {}, showModal, openErrorModal, shops, isAllShops, generalOrderTypes, shopId }) {
  const [stateObj, setStateObjRaw] = useState({
    modalOpen: false,
    promo: {},
    createPromo: false
  });
  const setStateObj = myNewObj => setStateObjRaw({ ...stateObj, ...myNewObj });
  const promotions = isAllShops ? getAllShopsPromotions(shops) : promos;
  const allOrderTypes = isAllShops ? generalOrderTypes : shopOrderTypes;
  const isZeltyEnabled = hasExternalIntegration(shopId) === ZELTY;
  const createTableRow = data => {
    return (
      <TableBody>
        {data.map((promo, i) => {
          const { promoCode, expired, type, nbUsed, count, orderTypes, minBasketPrice, startedDate, endedDate } = promo;
          const isPromoEditable = ((isAllShops && promo?.isGeneralData) || (!isAllShops && !isZeltyEnabled && !promo?.isGeneralData))
          return (
            <TableRow
              key={i.toString()}
              style={{ cursor: 'pointer' }}
              onClick={() => isPromoEditable && handleClick(setStateObj, false, promo)}
            >
              <TableCell align='center' className={classes.produits}>
                <p> <b>{promoCode}</b></p>
              </TableCell>
              <TableCell align='center' className={classes.produits}>
                {type === FREEDELIVERY ? (
                  <p>{PROMOTYPES.freeDelivery}</p>
                ) : isNaN(type) ? (
                  <p>{type}</p>
                ) : (
                  <p>{displayPriceFormat(type)}</p>
                )}
              </TableCell>
              <TableCell align='center' className={classes.produits}>
                <p className={classes.typo}>{`Par client: ${count || 0}`}</p>
                <p className={`mt-1 ${classes.typo}`}>{`Panier min : ${minBasketPrice || 0} €`}</p>
              </TableCell>

              <TableCell align='center' className={classes.produits}>
                <p>{parseDate(startedDate, endedDate)}</p>
              </TableCell>
              <TableCell align='center' className={classes.produits}>
                {' '}
                {orderTypes ? (
                  orderTypes.length < allOrderTypes.length ? (

                    orderTypes.map(orderType => {
                      return <p>{SUITABLE_ORDER_TYPES[orderType]}</p>;
                    })
                  ) : (
                    <p>Tous</p>
                  )
                ) : (
                  <p>Aucun</p>
                )}
              </TableCell>
              <TableCell align='center' className={classes.produits}>
                <p >{nbUsed || 0}</p>
              </TableCell>
              <TableCell
                align='center'
                className={classes.produits}
                onClick={e => {
                  e.stopPropagation();
                  isPromoEditable && handleRemove(promo, promotions, expired, setStateObj, showModal, openErrorModal);
                }}
              >
                {' '}
                <Switch checked={!expired} className={classes.icon} disabled={!isPromoEditable} />
                <p
                  style={{
                    color: expired === true ? mainColor.colorRed : mainColor.secondaryColor
                  }}
                  className={`${classes.space} float-left`}
                >{`${expired === true ? 'Désactivé' : 'Activé'}`}</p>
              </TableCell>
            </TableRow>
          );
        })}
      </TableBody>
    );
  };

  const renderCreatePromoButton = () => {
    return (
      <Button className='btn-xs-block mx-3' color='primary' onClick={() => handleClick(setStateObj, true)}>
        <div className='row justify-content-center align-items-center mr-0 ml-0'>
          <AddIcon />
          <p className='m-0 ml-2'> Créer un nouveau code promotionnel</p>
        </div>
      </Button>
    );
  };

  return (
    <div className='p-4 '>
      <BackButton
        className='p-0 pb-3'
        onClick={() => history.goBack()}
        title={marketing.codePromo.text}
        subtitle={marketing.codePromo.description}
      />
      {isObjectNotEmpty(promotions) ? (
        <>
          <Paper className='py-4'>
            <div className='pb-3'>
              <EmptyView
                src={ImportedSVG}
                title='Créer un nouveau code promotionnel'
                text={EMPTY_DESIGN_PROMOS_TEXT}
              >
                <div className='row pb-3'>{renderCreatePromoButton()}</div>
              </EmptyView>
            </div>
          </Paper>
          <h4 className='py-4'>Historique des codes promotionnels</h4>
          <Paper scrollOption='auto'>
            <Table
              headCells={PROMO_TABLE_HEAD}
              classes={classes}
              bodyRows={promotions}
              createTableRow={createTableRow}
              order='desc'
              orderBy='date'
            />
          </Paper>
          <TableFooter rowsPerPageOptions={[5, 10, 25]} lengthOption={_.keys(promotions).length} />
        </>
      ) : (
        <EmptyView
          src={ImportedSVG}
          title={EMPTY_DESIGN_PROMOS_TITLE}
          text={EMPTY_DESIGN_PROMOS_TEXT}
        >
          {renderCreatePromoButton()}
        </EmptyView>
      )}
      {stateObj.modalOpen && (
        <PromoModal
          promo={stateObj.promo}
          createPromo={stateObj.createPromo}
          isOpen={stateObj.modalOpen}
          closeModal={() => closeModal(setStateObj)}
          promotions={promotions}
        />
      )}
    </div>
  );

}

function mapStateToProps({ user, page, firebaseRealTime }) {
  const { shop = {}, shops, generalConfig } = firebaseRealTime;
  const { promotions, name, configuration = {} } = shop;
  const { nbShops, shopId, isAllShops } = user;
  const { orderTypes } = configuration;
  const { orderTypes: generalOrderTypes } = generalConfig
  return {
    promos: promotions,
    page,
    nbShops,
    shopId,
    name,
    orderTypes,
    shops,
    isAllShops,
    generalOrderTypes

  };
}

export default connect(mapStateToProps, actions)(withStyles(styles)(withRouter(CodePromo)));
